module.exports = __webpack_public_path__ + "f29e06de43342c65b4469fbbf5642d58.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/hygiene_top_fr_white.svg
// module id = 1267
// module chunks = 65